<template>
  <div class="timeselect">
    <span v-if="havetype" class="typetext">查询类型：</span>
    <el-select v-if="havetype" class="selectsize left" style="width: 150px" v-model="gettype" @change="typeChange">
      <el-option label="按采集间隔" value="0"></el-option>
      <el-option label="普通类型" value="1"></el-option>
    </el-select>
    <span class="typetext">时间类型：</span>
    <el-select :size="inputSize" class="selectsize left" v-model="datetype" @change="timeChange">
      <el-option v-for="item in timeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div v-show="datetype == '3'">
      <slot name="nhtjfxTimeSelect"></slot>
    </div>
    <div class="block left">
      <el-date-picker :size="inputSize" v-show="datetype == '-1'" v-model="typevalue" format="yyyy-MM-dd HH:00:00" align="center" :clearable="false" type="datetime" :picker-options="pickerOptions1" placeholder="选择时间"></el-date-picker>
      <el-date-picker :size="inputSize" v-model="typevalue" v-show="datetype == '0'" type="date" placeholder="选择日期" align="center" :clearable="false" :picker-options="pickerOptions" :editable="false"></el-date-picker>
      <el-date-picker :size="inputSize" v-model="typevalue" v-show="datetype == '1'" type="week" align="center" placeholder="选择日期" :clearable="false" :picker-options="pickerOptions" :editable="false"></el-date-picker>
      <el-date-picker :size="inputSize" v-model="typevalue" v-show="datetype == '2'" type="month" placeholder="选择日期" align="center" :clearable="false" :picker-options="pickerOptions" :editable="false"></el-date-picker>
      <!-- 时段，限制一个月范围 -->
      <el-date-picker :size="inputSize" v-model="typeValueStartTime" v-show="datetype == '3' && timeInterval == 'oneMonth'" type="datetime" format="yyyy-MM-dd HH:00:00" :picker-options="startTime" default-time="00:00:00" :editable="false" :clearable="false" @change="stratChange" placeholder="开始日期"></el-date-picker>
      <span class="data-span" v-show="datetype == '3' && timeInterval == 'oneMonth'">至</span>
      <el-date-picker :size="inputSize" v-model="typeValueEndTime" v-show="datetype == '3' && timeInterval == 'oneMonth'" format="yyyy-MM-dd HH:00:00" :picker-options="endTime" type="datetime" :editable="false" :clearable="false" default-time="23:00:00" @change="endChange" placeholder="结束日期"></el-date-picker>
      <!-- 时段，限制一个月范围 -->
      <!-- 时段，只到日，不到时 -->
      <el-date-picker :size="inputSize" v-model="StartDate" v-show="datetype == '3' && timeInterval == 'toDay'" type="date" format="yyyy-MM-dd" :picker-options="StartDateOptions" :editable="false" :clearable="false" @change="stratChange" placeholder="开始日期"></el-date-picker>
      <span class="data-span" v-show="datetype == '3' && timeInterval == 'toDay'">至</span>
      <el-date-picker :size="inputSize" v-model="EndDate" v-show="datetype == '3' && timeInterval == 'toDay'" format="yyyy-MM-dd" :picker-options="EndDateOptions" type="date" :editable="false" :clearable="false" @change="endChange" placeholder="结束日期"></el-date-picker>
      <!-- 时段，只到日，不到时 -->
      <!-- 时段，到时，不做限制 -->
      <el-date-picker :size="inputSize" :popper-class="alarnclass" v-model="typeValueStartTime" v-show="datetype == '3' && timeInterval == 'toTime'" type="datetime" :picker-options="startTimeNone" default-time="00:00:00" :editable="false" :clearable="false" @change="stratChange" placeholder="开始日期"></el-date-picker>
      <span class="data-span" v-show="datetype == '3' && timeInterval == 'toTime'">至</span>
      <el-date-picker :size="inputSize" :popper-class="alarnclass" v-model="typeValueEndTime" v-show="datetype == '3' && timeInterval == 'toTime'" :picker-options="endTimeNone" type="datetime" :editable="false" :clearable="false" default-time="23:00:00" @change="endChange" placeholder="结束日期"></el-date-picker>
      <!-- 时段，到时，不做限制 -->
      <!-- 大于31天提示 -->
      <el-date-picker :size="inputSize" :popper-class="alarnclass" v-model="typeValueStartTime" v-show="datetype == '3' && timeInterval == 'warntoTime'" type="datetime" :picker-options="warnstartTimeNone" default-time="00:00:00" :editable="false" :clearable="false" @change="stratChange_warn" placeholder="开始日期"></el-date-picker>
      <span class="data-span" v-show="datetype == '3' && timeInterval == 'warntoTime'">至</span>
      <el-date-picker :size="inputSize" :popper-class="alarnclass" v-model="typeValueEndTime" v-show="datetype == '3' && timeInterval == 'warntoTime'" :picker-options="warnendTimeNone" type="datetime" :editable="false" :clearable="false" default-time="23:00:00" @change="endChange_warn" placeholder="结束日期"></el-date-picker>
      <!-- 大于31天提示 -->
      <el-date-picker :size="inputSize" v-model="typevalue" v-show="datetype == '5'" type="year" align="center" placeholder="选择日期" :picker-options="pickerOptions" :editable="false" :clearable="false"></el-date-picker>
    </div>
    <slot></slot>
    <el-button :size="inputSize" type="primary" :style="inputSize == 'mini' ? 'height:28px' : ''" class="btn btn-v2" @click="getData">查询</el-button>
    <el-button type="primary" class="btn btn-v2" @click="exportExc" v-if="showExportBtn == true">导出</el-button>
    <slot name="btnslot"></slot>
  </div>
</template>
<script>
import DateTool from "@/utils/dateTool.js";
export default {
  props: {
    timeType: {
      type: Array,
      default: () => {
        return [
          {
            value: "-1",
            label: "时",
          },
          {
            value: "0",
            label: "日",
          },
          {
            value: "1",
            label: "周",
          },
          {
            value: "2",
            label: "月",
          },
          {
            value: "3",
            label: "时段",
          },
          {
            value: "5",
            label: "年",
          },
        ];
      },
    },
    havetype: {
      type: Boolean,
      default: false,
    },
    alarnclass: {
      //时段需要选分秒
      type: String,
      default: "",
    },
    showExportBtn: {
      type: Boolean,
      default: false,
    },
    timeInterval: {
      type: String,
      default: "warntoTime",
      //默认时段是限制一个月的，还有其它两种类型，都不限制范围，分别是“toDay”,只到日，“toTime”，到小时
    },
    inputSize: {
      //条件选择框的大小
      type: String,
      default: "",
    },
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
      },
      pickerMinDate: "",
      //时段，限制一个月范围
      startTime: {
        disabledDate: (time) => {
          let endDateVal = this.typeValueEndTime;
          let day31 = 31 * 24 * 3600 * 1000;
          if (endDateVal) {
            let minTime = new Date(endDateVal).getTime() - day31;
            return (
              time.getTime() > new Date(endDateVal).getTime() ||
              time.getTime() < minTime
            );
          }
        },
      },
      endTime: {
        disabledDate: (time) => {
          let beginDateVal = this.typeValueStartTime;
          let day31 = 31 * 24 * 3600 * 1000;
          if (beginDateVal) {
            let maxTime = new Date(beginDateVal).getTime() + day31;
            return (
              time.getTime() <=
              new Date(beginDateVal).getTime() - 24 * 60 * 60 * 1000 ||
              time.getTime() > Date.now() ||
              time.getTime() > maxTime
            );
          }
        },
      },
      //时段，限制一个月范围
      //时段，只到日，不做限制
      StartDateOptions: {
        disabledDate: (time) => {
          let endDateVal = this.EndDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      EndDateOptions: {
        disabledDate: (time) => {
          let beginDateVal = this.StartDate;
          if (beginDateVal) {
            return (
              time.getTime() <=
              new Date(beginDateVal).getTime() - 24 * 60 * 60 * 1000 ||
              time.getTime() > Date.now()
            );
          }
        },
      },
      //时段，只到日，不做限制
      //时段，到时，不做限制
      startTimeNone: {
        disabledDate: (time) => {
          let endDateVal = this.typeValueEndTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      endTimeNone: {
        disabledDate: (time) => {
          let beginDateVal = this.typeValueStartTime;
          if (beginDateVal) {
            return (
              time.getTime() <=
              new Date(beginDateVal).getTime() - 24 * 60 * 60 * 1000 ||
              time.getTime() > Date.now()
            );
          }
        },
      },
      //时段，到时，不做限制
      //大于31天提示
      warnstartTimeNone: {
        disabledDate: (time) => {
          let endDateVal = this.typeValueEndTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      warnendTimeNone: {
        disabledDate: (time) => {
          let beginDateVal = this.typeValueStartTime;
          if (beginDateVal) {
            return (
              time.getTime() <=
              new Date(beginDateVal).getTime() - 24 * 60 * 60 * 1000 ||
              time.getTime() > Date.now()
            );
          }
        },
      },
      //大于31天提示
      datetype: "-1",
      typevalue: "", //非时段所用
      typeValueStartTime: "", //开始时间
      typeValueEndTime: "", //结束时间
      StartDate: "", //开始日期
      EndDate: "", //结束日期
      gettype: "1",
      havetype_: "", //是否显示查询类型选择框
    };
  },
  watch: {
    timeType () {
      this.datetype = this.timeType[0].value; //设置默认选中的日期
    },
    havetype (curVal, oldVal) {
      this.havetype = curVal;
    },
  },
  created () {
    this.datetype = this.timeType[0].value; //设置默认选中的日期
    this.getdatatime();
    this.getDateTime();
  },
  methods: {
    getdatatime () {
      this.typevalue = new Date();
      var now = this.typevalue;
      var year = now.getFullYear(); //年
      var month = now.getMonth() + 1; //月
      var day = now.getDate(); //日
      var clock = year + "/";
      if (month < 10) {
        clock += "0";
      }
      clock += month + "/";
      if (day < 10) {
        clock += "0";
      }
      clock += day + " ";
      this.StartDate = clock;
      this.EndDate = clock;
    },
    getDateTime () {
      let dateTime = new Date();
      let year = dateTime.getFullYear(); //年
      let month = dateTime.getMonth() + 1; //月
      let day = dateTime.getDate(); //日
      let clock = year + "/";
      if (month < 10) {
        clock += "0";
      }
      clock += month + "/";
      if (day < 10) {
        clock += "0";
      }
      clock += day + " ";
      this.typeValueStartTime = clock + " 00:00:00";
      this.typeValueEndTime = clock + " " + dateTime.getHours() + ":00:00";
    },
    stratChange (value) {
      this.typeValueStartTime = value;
      if (value.getTime() >= new Date(this.typeValueEndTime).getTime()) {
        this.typeValueStartTime = this.typeValueEndTime;
      }
    },
    endChange (value) {
      this.typeValueEndTime = value;
      if (value.getTime() <= new Date(this.typeValueStartTime).getTime()) {
        this.typeValueEndTime = this.typeValueStartTime;
      }
    },
    stratChange_warn (value) {
      this.typeValueStartTime = value;
      if (value.getTime() >= new Date(this.typeValueEndTime).getTime()) {
        this.typeValueStartTime = this.typeValueEndTime;
      }
      let endDateVal = this.typeValueEndTime;
      let beginDateVal = this.typeValueStartTime;
      let day31 = 31 * 24 * 3600 * 1000;

      //判断是不是大于三天。如果大于。关闭显示采集间隔的显示
      if (
        new Date(endDateVal).getTime() - new Date(beginDateVal).getTime() >
        3 * 24 * 60 * 60 * 1000
      ) {
        this.$emit("cangeGettype", false);
      } else if (
        new Date(endDateVal).getTime() - new Date(beginDateVal).getTime() >
        day31
      ) {
        this.$notify({
          title: "操作提示",
          message: "时段已超过31天,请重新选择",
          position: "bottom-right",
        });
        //this.typeValueStartTime = ""
      }
    },
    endChange_warn (value) {
      console.log(value);
      this.typeValueEndTime = value;
      if (value.getTime() <= new Date(this.typeValueStartTime).getTime()) {
        this.typeValueEndTime = this.typeValueStartTime;
      }
      let endDateVal = this.typeValueEndTime;
      let beginDateVal = this.typeValueStartTime;
      let day31 = 31 * 24 * 3600 * 1000;

      //判断是不是大于三天。如果大于。关闭显示采集间隔的显示
      if (
        new Date(endDateVal).getTime() - new Date(beginDateVal).getTime() >
        3 * 24 * 60 * 60 * 1000
      ) {
        this.$emit("cangeGettype", false);
      } else if (
        new Date(endDateVal).getTime() - new Date(beginDateVal).getTime() >
        day31
      ) {
        this.$notify({
          title: "操作提示",
          message: "时段已超过31天,请重新选择",
          position: "bottom-right",
        });
        //this.typeValueEndTime = ""
      }
    },
    timeChange (value) {
      if (value != 0 && value != 3) {
        //改变查询类型是否显示
        this.$emit("cangeGettype", false);
      } else {
        this.$emit("cangeGettype", true);
      }
    },
    typeChange (value) {
      this.$emit("cangetype", value);
    },
    getData () {
      //点击查询按钮
      this.$emit("getData", this.getElem());
    },
    exportExc () {
      //点击导出模板
      this.$emit("exportExc");
    },
    getElem () {
      //获取时间类型，开始时间，结束时间三个参数
      let fromDate = "";
      let toDate = "";
      switch (this.datetype) {
        case "-1": {
          fromDate = DateTool.format(
            new Date(this.typevalue),
            "yyyy-MM-dd hh:00:00"
          );
          toDate = DateTool.format(
            new Date(this.typevalue),
            "yyyy-MM-dd hh:59:59"
          );
          break;
        }
        case "0": {
          fromDate = DateTool.format(
            new Date(this.typevalue),
            "yyyy-MM-dd 00:00:00"
          );
          let end = new Date(this.typevalue);
          end.setDate(this.typevalue.getDate() + 1);
          toDate = DateTool.format(end, "yyyy-MM-dd") + " 00:00:00";
          break;
        }
        case "1": {
          let now = new Date(this.typevalue);
          let nowTime = now.getTime();
          let day = now.getDay();
          let oneDayLong = 24 * 60 * 60 * 1000;
          let mondayTime = nowTime - day * oneDayLong;
          let sundayTime = nowTime + (6 - day) * oneDayLong;
          let monday = new Date(mondayTime);
          let sunday = new Date(sundayTime);

          fromDate = DateTool.format(new Date(monday), "yyyy-MM-dd 00:00:00");
          toDate = DateTool.format(new Date(sunday), "yyyy-MM-dd 23:59:59");
          break;
        }
        case "2": {
          fromDate =
            DateTool.format(this.typevalue, "yyyy-MM") + "/01 00:00:00";
          let end = new Date(this.typevalue);
          end.setMonth(this.typevalue.getMonth() + 1);
          toDate = DateTool.format(end, "yyyy-MM") + "/01 00:00:00";
          break;
        }
        case "3": {
          if (this.timeInterval == "toDay") {
            //只到日
            fromDate = DateTool.format(
              new Date(this.StartDate),
              "yyyy-MM-dd 00:00:00"
            );
            // toDate =
            //   DateTool.format(
            //     new Date(
            //       new Date(this.EndDate).getTime() + 24 * 60 * 60 * 1000
            //     ),
            //     "yyyy-MM-dd"
            //   ) + " 00:00:00";

            let end = new Date(this.EndDate);
            end.setDate(this.EndDate.getDate() + 1);
            toDate = DateTool.format(end, "yyyy-MM-dd") + " 00:00:00";
          } else if (
            (this.timeInterval == "warntoTime" &&
              this.alarnclass == "alarnclass") ||
            (this.timeInterval == "toTime" && this.alarnclass == "alarnclass")
          ) {
            fromDate = DateTool.format(
              new Date(this.typeValueStartTime),
              "yyyy-MM-dd hh:mm:ss"
            );
            toDate = DateTool.format(
              new Date(this.typeValueEndTime),
              "yyyy-MM-dd hh:mm:ss"
            );
          } else {
            //到小时，限制一个月内或不限制
            fromDate = DateTool.format(
              new Date(this.typeValueStartTime),
              "yyyy-MM-dd hh:00:00"
            );
            toDate = DateTool.format(
              new Date(this.typeValueEndTime),
              "yyyy-MM-dd hh:59:59"
            );
          }
          break;
        }
        case "5": {
          fromDate =
            DateTool.format(new Date(this.typevalue), "yyyy") +
            "/01/01 00:00:00";
          let end = new Date(this.typevalue);
          end.setFullYear(new Date(this.typevalue).getFullYear() + 1);
          toDate = DateTool.format(end, "yyyy") + "/01/01 00:00:00";
          break;
        }
        default: {
          break;
        }
      }
      let elem = {
        dateType: this.datetype,
        fromDate: fromDate,
        toDate: toDate,
      };
      return elem;
    },
  },
};
</script>

<style scoped>
.timeselect {
  width: 100%;
  padding: 14px;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background: #fff;
}
.selectsize {
  width: 100px;
  padding: 0 5px;
}
.typetext {
  font: 400 14px "Microsoft YaHei";
  color: #666;
}
.btn {
  margin: 0 5px;
  height: 40px;
  background: #3267cf;
  border-color: #3267cf;
}
.data-span {
  color: #666;
  font-size: 0.7rem;
  padding: 0px 10px;
}
</style>
